import {getStore} from "../utils/storage";

//字母数字自然增序排序
export const signStr = () => {
  let arry = [Date.parse(new Date()),'H5',getStore('token') || '','(&#($23348EIJIEW'];
  let str = '';
  arry.sort((a,b)=>
    a.toString().toLowerCase().replace(/\>| |\-/g,'')
      .localeCompare(
        b.toString().toLowerCase().replace(/\>| |\-/g,''),
        undefined,{numeric:true, sensitivity:'base'}));
  arry.map((item,ind)=>{
    str += item;
    return item;
  });
  return str
};



// WEBPACK FOOTER //
// ./src/utils/signFn.js